import { render, staticRenderFns } from "./ArticuloFamilia.vue?vue&type=template&id=145db5f2&scoped=true&"
import script from "./ArticuloFamilia.vue?vue&type=script&lang=js&"
export * from "./ArticuloFamilia.vue?vue&type=script&lang=js&"
import style0 from "./ArticuloFamilia.vue?vue&type=style&index=0&id=145db5f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145db5f2",
  null
  
)

export default component.exports